/**
 * Resuelve un array de nombres de equipos a sus IDs usando el catálogo cacheado.
 * Devuelve { ids: number[], allResolved: boolean }.
 * Si algún nombre no resuelve, allResolved=false (caller decide el fallback).
 *
 * @param {string[]} names - Nombres seleccionados en el select de equipos.
 * @param {Array<{nombre: string, id: number}>} clientAscensores - Catálogo cargado para el cliente.
 * @returns {{ ids: number[], allResolved: boolean }}
 */
export function resolveNamesToIds(names, clientAscensores) {
  if (!Array.isArray(names) || names.length === 0) return { ids: [], allResolved: true };
  const byName = new Map((clientAscensores || []).map((a) => [a.nombre, a.id]));
  const ids = [];
  let allResolved = true;
  for (const name of names) {
    const id = byName.get(name);
    if (id == null) {
      allResolved = false;
      break;
    }
    ids.push(id);
  }
  return { ids, allResolved };
}
